import { IFacet } from '@ucheba/utils/types/search'
import { EInstitutionMediaType, IImage, IInstitutionFeedbackStats } from './item/types'
import { institutionsSlice } from './index'

export interface IInstitutionsState {
  [key: string]: ReturnType<typeof institutionsSlice.reducer>
}

export interface IInstitutions {
  total: number
  items: IItemOfInstitutions[]
  facets?: IInstitutionsFacets
}

export enum EEventsFacets {
  tags = 'tags',
  locations = 'locations',
}

interface IInstitutionsFacets {
  [EEventsFacets.tags]: IFacet[]
  [EEventsFacets.locations]: IFacet[]
}

export interface IItemOfInstitutions {
  id: number
  name: string
  type: {
    value: number
    name: string
  }
  feedbackStats: IInstitutionFeedbackStats
  isState: boolean
  abbreviation: string
  description: string
  logo: IImage
  programSummary: {
    count: number
    budgetPlacesCount: number
    minPassingScore: number
    maxPassingScore: number
    priceFrom: number
    priceTo: number
  }
  mediaList: IInstitutionsMedia[]
  rankings: IInstitutionsRanking[]
}

interface IPromoImageFormat {
  fullUrl: IImage
  thumbBig: IImage
  thumbMid: IImage
  thumbMin: IImage
}

interface IInstitutionsMedia {
  id: number
  fileUrl: string | null
  thumbnailUrl: string | null
  mediaType: {
    name: string
    value: EInstitutionMediaType
  }
  image: IPromoImageFormat | null

  isOfficialPromo: boolean
  description: string
}

export interface IInstitutionsRanking {
  ranking: {
    id: number
    name: string
    description: string | null
    url: string | null
    logo: IImage
  }
  rankFrom: number | null
  rankTo: number | null
  worldRankFrom: number | null
  worldRankTo: number | null
  isOutOfRank: boolean
  isOutOfWorldRank: boolean
}

export enum EMediaType {
  video = 10,
  image = 1,
}
